<div class="parallax order-classroom-materials-page">
  <div class="gradesHeaderImg container">
    <section class="backgroundImages" style="top: 0px;">
      <div class="centeredDiv zoom-images">
        <h1>{{ 'orderMaterials.title' | translate }}</h1>
        <div anchor-target="body" class="heroOverlay"
            data-600-start="background:rgba(0, 0, 0, 0.5)" data-start="background:rgba(0, 0, 0, 0)"></div>
        <div anchor-target="body" class="backgroundImage adjust-top" data-600-start="transform: scale(1.3)"
            data-start="transform: scale(1)" id="materialsHeader"></div>
      </div>
    </section>
  </div>
  <div class="container main order-materials" id="skrollr-body">
    <div *ngIf="!emailSent" class="main-content-box">
      <div class="introduction">
        <h2 class="c11n-text-lg-bold">
          {{ 'orderMaterials.description_part1' | translate }}
          <br>
          {{ 'orderMaterials.description_part2' | translate }}
        </h2>
        <div class="w-100">
          <c11n-details
            class="c11n-text-sm"
            collapseLabelText="{{ 'informationRequest.header' | translate }}"
            expandLabelText="{{ 'informationRequest.header' | translate }}"
            [labelWeight]="'normal'"
          >
            <div class="c11n-text-sm c11n-details__content">
              {{ 'informationRequest.paperOrder' | translate }} 
              <br/>
              <br/>
              {{ 'informationRequest.privacy_note' | translate }}
            </div>
          </c11n-details>
        </div>
      </div>
      <form class="order-materials-form" [formGroup]="orderMaterialsForm" (ngSubmit)="onSubmit()" focusInvalidInput autocomplete="on">
        <p class="c11n-text-sm"><span class="required-asterisk">*</span> {{ 'formFields.required' | translate }}</p>
        <div class="form-section">
          <h3 class="c11n-text-lg-headline m-0">{{ 'orderMaterials.sections.contact' | translate }}</h3>
          <div class="field-group">
            <div class="row w-100 inherit-row-gap">
              <div class="col-sm-6">
                <label c11n-label for="firstName">{{ 'formFields.firstName' | translate }} <span class="required-asterisk">*</span></label>
    
                <c11n-input [hasError]="isSubmittedAndInvalid && orderMaterialsForm.controls['firstName']?.errors">
                  <input
                    c11nInput
                    formControlName="firstName" 
                    id="firstName"
                    name="firstName"
                    autocomplete="given-name"
                    type="text"
                    [attr.aria-describedby]="'first-name-description'"
                  />
                </c11n-input>
                <c11n-hint-error 
                  [hasError]="isSubmittedAndInvalid && orderMaterialsForm.controls['firstName'].hasError('required')"
                  *ngIf="isSubmittedAndInvalid && orderMaterialsForm.controls['firstName'].hasError('required')"
                  [hintErrorId]="'first-name-description'" 
                  errorText="{{ 'formErrors.firstName.required' | translate }}"
                  >
                </c11n-hint-error>
                <c11n-hint-error 
                  [hasError]="isSubmittedAndInvalid && orderMaterialsForm.controls['firstName'].hasError('maxlength')"
                  *ngIf="isSubmittedAndInvalid && orderMaterialsForm.controls['firstName'].hasError('maxlength')"
                  [hintErrorId]="'first-name-description'"
                  errorText="{{ 'formErrors.firstName.max' | translate }}">
                </c11n-hint-error>
                <c11n-hint-error 
                  [hasError]="isSubmittedAndInvalid && 
                    orderMaterialsForm.controls['firstName'].hasError('pattern') &&
                    !(orderMaterialsForm.controls['firstName'].hasError('maxlength'))"
                  *ngIf="isSubmittedAndInvalid && 
                    orderMaterialsForm.controls['firstName'].hasError('pattern') &&
                    !(orderMaterialsForm.controls['firstName'].hasError('maxlength'))"
                  [hintErrorId]="'first-name-description'"
                  errorText="{{ 'formErrors.firstName.specialCharacters' | translate }}">
                </c11n-hint-error>
              </div>
              <div class="col-sm-6">
                <label c11n-label for="lastName">{{ 'formFields.lastName' | translate }} <span class="required-asterisk">*</span></label>
    
                <c11n-input [hasError]="isSubmittedAndInvalid && orderMaterialsForm.controls['lastName']?.errors">
                  <input
                    c11nInput
                    formControlName="lastName" 
                    id="lastName"
                    name="lastName"
                    type="text"
                    autocomplete="family-name"
                    [attr.aria-describedby]="'last-name-description'"
                  />
                </c11n-input>
                <c11n-hint-error 
                  [hasError]="isSubmittedAndInvalid && orderMaterialsForm.controls['lastName'].hasError('required')"
                  *ngIf="isSubmittedAndInvalid && orderMaterialsForm.controls['lastName'].hasError('required')"
                  [hintErrorId]="'last-name-description'" 
                  errorText="{{ 'formErrors.lastName.required' | translate }}"
                  >
                </c11n-hint-error>
                <c11n-hint-error 
                  [hasError]="isSubmittedAndInvalid && orderMaterialsForm.controls['lastName'].hasError('maxlength')"
                  *ngIf="isSubmittedAndInvalid && orderMaterialsForm.controls['lastName'].hasError('maxlength')"
                  [hintErrorId]="'last-name-description'"
                  errorText="{{ 'formErrors.lastName.max' | translate }}">
                </c11n-hint-error>
                <c11n-hint-error 
                  [hasError]="isSubmittedAndInvalid && orderMaterialsForm.controls['lastName'].getError('pattern') && !(orderMaterialsForm.controls['lastName'].hasError('maxlength'))"
                  *ngIf="isSubmittedAndInvalid && orderMaterialsForm.controls['lastName'].getError('pattern') && !(orderMaterialsForm.controls['lastName'].hasError('maxlength'))"
                  [hintErrorId]="'last-name-description'"
                  errorText="{{ 'formErrors.lastName.specialCharacters' | translate }}">
                </c11n-hint-error>
              </div>
            </div>
            <div class="row w-100 inherit-row-gap">
              <div class="col-sm-12">
                <label c11n-label for="email">{{ 'formFields.email' | translate }} <span class="required-asterisk">*</span></label>
                <c11n-input
                  [hasError]="isSubmittedAndInvalid && orderMaterialsForm.controls['email']?.errors">
                    <input
                      c11nInput
                      placeholder="user@domain.com"
                      formControlName="email" 
                      id="email"
                      name="email"
                      type="email"
                      autocomplete="email"
                      [attr.aria-describedby]="'email-description'"
                    />
                </c11n-input>
                <c11n-hint-error 
                  [hasError]="isSubmittedAndInvalid && 
                    (orderMaterialsForm.controls['email'].getError('required') || orderMaterialsForm.controls['email'].getError('pattern'))"
                  *ngIf="isSubmittedAndInvalid && 
                    (orderMaterialsForm.controls['email'].getError('required') || orderMaterialsForm.controls['email'].getError('pattern'))"
                  [hintErrorId]="'email-description'"
                  errorText="{{ 'formErrors.email.invalid' | translate }}" 
                  >
                </c11n-hint-error>
                <c11n-hint-error 
                  [hasError]="isSubmittedAndInvalid && 
                    orderMaterialsForm.controls['email'].hasError('maxlength') &&
                    !(orderMaterialsForm.controls['email'].getError('required') || orderMaterialsForm.controls['email'].getError('pattern'))"
                  *ngIf="isSubmittedAndInvalid && 
                    orderMaterialsForm.controls['email'].hasError('maxlength') &&
                    !(orderMaterialsForm.controls['email'].getError('required') || orderMaterialsForm.controls['email'].getError('pattern'))"
                  [hintErrorId]="'email-description'"
                  errorText="{{ 'formErrors.email.max' | translate }}" 
                  >
                </c11n-hint-error>
              </div>
            </div>
          </div>
        </div>

        <div class="form-section">
          <h3 class="c11n-text-lg-headline m-0">{{ 'orderMaterials.sections.school' | translate }}</h3>
          <div class="field-group">
            <ng-container *ngIf="!enableAddSchoolMode">
              <ng-container
                [ngTemplateOutlet]="selectedSchoolMetaData?.schoolMetaDataId ? selectedSchoolFromSearch : schoolSearchTemplate">
              </ng-container>
            </ng-container>
    
            <ng-container *ngIf="enableAddSchoolMode">
              <div class="row w-100 inherit-row-gap">
                <div class="col-sm-12">
                  <div class="back-to-search mb-2 mt-1">
                    <a c11n-link [iconName]="'search'" [variant]="'primary-independent'" [iconPosition]="'leading'"
                      [fontWeight]="'bold'" href="javascript:void(0)" autofocus (click)="returnToSearch()">{{
                      'formFields.schoolSearch.return_to_school_search' | translate }}</a>
                  </div>
                  <label c11n-label for="formFieldSchoolCountryRegion">{{ 'formFields.country'
                    | translate }}
                  </label>
                  <div class="input-width-small">
                    <c11n-select 
                      [size]="'medium'" 
                      [hideLabel]="true" 
                      [hintText]="''" 
                      (stateChange)="onSchoolAddressCountryChange($event)">
                      <select c11nSelectInput formControlName="schoolcountryregion" id="formFieldSchoolCountryRegion"
                        class="form-control c11n-select__box__select shadow-none"
                        [attr.aria-label]="'formFields.country' | translate">
                        <option *ngFor="let country of countries | keyvalue : preserveOriginalOrder" 
                          [value]="country.value">{{ 'countries.' + country.key | translate }}
                        </option>
                      </select>
                    </c11n-select>
                  </div>
                </div>
              </div>
    
              <div class="row w-100 inherit-row-gap">
                <div class="col-sm-12">
                  <label for="formFieldSchoolName" c11n-label>{{
                    'formFields.school' | translate
                    }}</label>
                  <c11n-input [size]="'medium'" [hasError]="isSubmittedAndInvalid && orderMaterialsForm.controls['schoolName']?.errors">
                    <input c11nInput formControlName="schoolName" type="text" class="form-control shadow-none"
                      id="formFieldSchoolName" [attr.aria-describedby]="'schoolname-description'"
                      [attr.aria-label]="'formFields.school' | translate" />
                  </c11n-input>
                  <c11n-hint-error [hasError]="
                      isSubmittedAndInvalid &&
                      orderMaterialsForm.controls['schoolName'].hasError('required')
                    " *ngIf="
                      isSubmittedAndInvalid &&
                      orderMaterialsForm.controls['schoolName'].hasError('required')
                    " [hintErrorId]="'schoolname-description'" [errorText]="
                      'formErrors.school.required' | translate
                    " [size]="'medium'">
                  </c11n-hint-error>
                  <c11n-hint-error [hasError]="
                      isSubmittedAndInvalid &&
                      orderMaterialsForm.controls['schoolName'].hasError('maxlength')
                    " *ngIf="
                      isSubmittedAndInvalid &&
                      orderMaterialsForm.controls['schoolName'].hasError('maxlength')
                    " [hintErrorId]="'schoolname-description'" [errorText]="
                      'formErrors.school.max' | translate
                    " [size]="'medium'">
                  </c11n-hint-error>
                  <c11n-hint-error 
                    [hasError]="isSubmittedAndInvalid && 
                      orderMaterialsForm.controls['schoolName'].getError('pattern') &&
                      !(orderMaterialsForm.controls['schoolName'].getError('maxlength'))" 
                    *ngIf="isSubmittedAndInvalid && 
                      orderMaterialsForm.controls['schoolName'].getError('pattern') &&
                      !(orderMaterialsForm.controls['schoolName'].getError('maxlength'))" 
                    [hintErrorId]="'school-name-description'" 
                    errorText="{{ 'formErrors.school.specialCharacters' | translate }}" 
                    >
                  </c11n-hint-error>
                </div>
              </div>
    
              <div class="row w-100 inherit-row-gap">
                <div class="col-sm-8">
                  <label c11n-label for="formFieldSchoolStreetAddress">{{
                    'formFields.streetAddress' | translate
                    }}</label>
                  <c11n-input [size]="'medium'" [hasError]="isSubmittedAndInvalid && orderMaterialsForm.controls['schoolstreetaddress']?.errors">
                    <input c11nInput formControlName="schoolstreetaddress" type="text" class="form-control shadow-none"
                      id="formFieldSchoolStreetAddress"
                      [attr.aria-describedby]="'schoolstreetaddress-description'"
                      [attr.aria-label]="'formFields.streetAddress' | translate" />
                  </c11n-input>
                  <c11n-hint-error [hasError]="
                      isSubmittedAndInvalid &&
                      orderMaterialsForm.controls['schoolstreetaddress'].hasError('required')
                    " *ngIf="
                      isSubmittedAndInvalid &&
                      orderMaterialsForm.controls['schoolstreetaddress'].hasError('required')
                    " [hintErrorId]="'schoolstreetaddress-description'" [errorText]="
                      'formErrors.streetAddress.required' | translate
                    " [size]="'medium'">
                    </c11n-hint-error>
                  <c11n-hint-error 
                    [hasError]="isSubmittedAndInvalid && orderMaterialsForm.controls['schoolstreetaddress'].hasError('maxlength')"
                    *ngIf="isSubmittedAndInvalid && orderMaterialsForm.controls['schoolstreetaddress'].hasError('maxlength')"
                    [hintErrorId]="'schoolstreetaddress-description'"
                    errorText="{{ 'formErrors.streetAddress.max' | translate }}" >
                  </c11n-hint-error>
                  <c11n-hint-error 
                    [hasError]="isSubmittedAndInvalid && 
                    orderMaterialsForm.controls['schoolstreetaddress'].hasError('pattern') &&
                      !(orderMaterialsForm.controls['schoolstreetaddress'].hasError('maxlength'))"
                    *ngIf="isSubmittedAndInvalid && 
                    orderMaterialsForm.controls['schoolstreetaddress'].hasError('pattern') &&
                      !(orderMaterialsForm.controls['schoolstreetaddress'].hasError('maxlength'))"
                      [hintErrorId]="'schoolstreetaddress-description'"
                    errorText="{{ 'formErrors.streetAddress.specialCharacters' | translate }}" >
                  </c11n-hint-error>
                </div>
                <div class="col-sm-4">
                  <label c11n-label for="schoolsecondaryaddressunit">{{ 'formFields.secondaryAddressUnit' | translate }}</label>
                  <c11n-input 
                    [hasError]="isSubmittedAndInvalid && orderMaterialsForm.controls['schoolsecondaryaddressunit']?.errors">
                      <input
                        c11nInput
                        formControlName="schoolsecondaryaddressunit" 
                        id="schoolsecondaryaddressunit"
                        name="schoolsecondaryaddressunit"
                        [attr.aria-describedby]="'schoolsecondaryaddressunit-description'"
                      />
                  </c11n-input>
                  <c11n-hint-error 
                    [hasError]="isSubmittedAndInvalid && orderMaterialsForm.controls['schoolsecondaryaddressunit'].hasError('maxlength')"
                    *ngIf="isSubmittedAndInvalid && orderMaterialsForm.controls['schoolsecondaryaddressunit'].hasError('maxlength')"
                    [hintErrorId]="'schoolsecondaryaddressunit-description'"
                    errorText="{{ 'formErrors.secondaryAddressUnit.max' | translate }}" >
                  </c11n-hint-error>
                  <c11n-hint-error 
                    [hasError]="isSubmittedAndInvalid && 
                      orderMaterialsForm.controls['schoolsecondaryaddressunit'].hasError('pattern') &&
                      !(orderMaterialsForm.controls['schoolsecondaryaddressunit'].hasError('maxlength'))"
                    *ngIf="isSubmittedAndInvalid && 
                      orderMaterialsForm.controls['schoolsecondaryaddressunit'].hasError('pattern') &&
                      !(orderMaterialsForm.controls['schoolsecondaryaddressunit'].hasError('maxlength'))"
                    [hintErrorId]="'schoolsecondaryaddressunit-description'"
                    errorText="{{ 'formErrors.secondaryAddressUnit.specialCharacters' | translate }}" >
                  </c11n-hint-error>
                </div>
              </div>
    
              <div class="row w-100 inherit-row-gap">
                <div class="col-12 col-md-9 schoolcity-input">
                  <label c11n-label for="formFieldSchoolCity">{{
                    'formFields.city' | translate
                    }}</label>
                  <c11n-input [size]="'medium'" [hasError]="isSubmittedAndInvalid && orderMaterialsForm.controls['schoolcity']?.errors">
                    <input c11nInput formControlName="schoolcity" type="text" class="form-control shadow-none"
                      id="formFieldSchoolCity" [attr.aria-describedby]="'schoolcity-description'"
                      [attr.aria-label]="'formFields.city' | translate" />
                  </c11n-input>
                  <c11n-hint-error [hasError]="
                      isSubmittedAndInvalid &&
                      orderMaterialsForm.controls['schoolcity'].hasError('required')
                    " *ngIf="
                      isSubmittedAndInvalid &&
                      orderMaterialsForm.controls['schoolcity'].hasError('required')
                    " [hintErrorId]="'schoolcity-description'" [errorText]="
                      'formErrors.city.required' | translate
                    " [size]="'medium'">
                  </c11n-hint-error>
                  <c11n-hint-error 
                    [hasError]="isSubmittedAndInvalid && orderMaterialsForm.controls['schoolcity'].hasError('maxlength')"
                    *ngIf="isSubmittedAndInvalid && orderMaterialsForm.controls['schoolcity'].hasError('maxlength')"
                    [hintErrorId]="'schoolcity-description'"
                    errorText="{{ 'formErrors.city.max' | translate }}">
                  </c11n-hint-error>
                  <c11n-hint-error 
                    [hasError]="isSubmittedAndInvalid && 
                      orderMaterialsForm.controls['schoolcity'].hasError('pattern') &&
                      !(orderMaterialsForm.controls['schoolcity'].hasError('maxlength'))"
                    *ngIf="isSubmittedAndInvalid && 
                      orderMaterialsForm.controls['schoolcity'].hasError('pattern') &&
                      !(orderMaterialsForm.controls['schoolcity'].hasError('maxlength'))"
                    [hintErrorId]="'schoolcity-description'"
                    errorText="{{ 'formErrors.city.specialCharacters' | translate }}">
                  </c11n-hint-error>
                </div>
                <div class="col-12 col-md-3">
                  <div *ngIf="orderMaterialsForm.value.schoolcountryregion === this.countries.unitedStates">
                    <label c11n-label for="formFieldSchoolState">{{
                      'formFields.state' | translate
                      }}</label>
                    <c11n-input 
                      [size]="'medium'" 
                      [hasError]="isSubmittedAndInvalid && orderMaterialsForm.controls['schoolstate']?.errors">
                      <input 
                        c11nInput 
                        formControlName="schoolstate" 
                        type="text" 
                        maxlength="2"
                        (input)="
                          orderMaterialsForm
                            .get('schoolstate')
                            ?.setValue($any($event.target).value?.toUpperCase())
                        "
                        autocapitalize="characters"
                        class="form-control shadow-none"
                        id="formFieldSchoolState"
                        [attr.aria-describedby]="'schoolstate-description'"
                        [attr.aria-label]="'formFields.state' | translate" />
                    </c11n-input>
                    <c11n-hint-error [hasError]="
                        isSubmittedAndInvalid &&
                        orderMaterialsForm.controls['schoolstate'].hasError('required')
                      " *ngIf="
                        isSubmittedAndInvalid &&
                        orderMaterialsForm.controls['schoolstate'].hasError('required')
                      " [hintErrorId]="'schoolstate-description'" [errorText]="
                        'formErrors.state.required' | translate
                      " [size]="'medium'">
                    </c11n-hint-error>
                    <c11n-hint-error 
                      [hasError]="isSubmittedAndInvalid && orderMaterialsForm.controls['schoolstate'].hasError('isIn') && !(orderMaterialsForm.controls['schoolstate'].hasError('required'))"
                      *ngIf="isSubmittedAndInvalid && orderMaterialsForm.controls['schoolstate'].hasError('isIn') && !(orderMaterialsForm.controls['schoolstate'].hasError('required'))"
                      [hintErrorId]="'schoolstate-description'"
                      errorText="{{ 'formErrors.state.invalid' | translate }}">
                    </c11n-hint-error>
                  </div>
                  <div *ngIf="orderMaterialsForm.value.schoolcountryregion === this.countries.canada">
                    <label c11n-label for="formFieldSchoolState">{{
                      'formFields.province' | translate
                    }}</label>
                    <c11n-select
                      [hintText]="''"
                      errorText="{{ 'formErrors.province.required' | translate }}"
                      [hasError]="isSubmittedAndInvalid && orderMaterialsForm.controls['schoolstate']?.errors"
                      [hideLabel]="true"
                    >
                      <select c11nSelectInput id="formFieldSchoolState" required formControlName="schoolstate">
                        <option value="" data-option="placeholder" disabled selected>{{ 'formFields.select' | translate }}</option>
                        <option *ngFor="let province of provinces" [value]="province.canadianProvinceCode">{{ province.name }}</option>
                      </select>
                    </c11n-select>
                  </div>
                </div>
              </div>
    
              <div class="row w-100 inherit-row-gap">
                <div class="col-12 col-md-5">
                  <label c11n-label for="formFieldSchoolZipCode">{{ 'formFields.schoolSearch.schoolZipCode' | translate
                    }}</label>
                  <c11n-input [size]="'medium'" [hasError]="isSubmittedAndInvalid && orderMaterialsForm.controls['schoolZipCode']?.errors">
                    <input c11nInput formControlName="schoolZipCode" type="text" class="form-control shadow-none"
                      id="formFieldSchoolZipCode" [attr.aria-describedby]="'schoolzipcode-description'"
                      [attr.aria-label]="'formFields.schoolSearch.schoolZipCode' | translate" />
                  </c11n-input>
                  <c11n-hint-error [hasError]="
                      isSubmittedAndInvalid &&
                      orderMaterialsForm.controls['schoolZipCode'].hasError('required')
                    " *ngIf="
                      isSubmittedAndInvalid &&
                      orderMaterialsForm.controls['schoolZipCode'].hasError('required')
                    " [hintErrorId]="'schoolzipcode-description'" [errorText]="
                      'formErrors.zipCode.required' | translate
                    " [size]="'medium'">
                  </c11n-hint-error>
                  <c11n-hint-error [hasError]=" 
                      isSubmittedAndInvalid &&
                      orderMaterialsForm.controls['schoolZipCode'].hasError('inValidZip')
                    " *ngIf="
                      isSubmittedAndInvalid &&
                      orderMaterialsForm.controls['schoolZipCode'].hasError('inValidZip')
                    " [hintErrorId]="'schoolzipcode-description'" [errorText]="
                      'formErrors.zipCode.invalid' | translate
                    " [size]="'medium'">
                  </c11n-hint-error>
                </div>
              </div>
            </ng-container>

            <div [formArrayName]="'gradeKitOrders'" class="grade-kit-rows">
              <div *ngFor="let gradeKitOrder of gradeKitOrders.controls; index as i;" class="row w-100 grade-kit-group" [formGroupName]="i">
                <div class="col-7 col-md-4">
                  <label c11n-label for="gradeLevel_{{gradeKitOrder.value.tempId}}" >{{ 'formFields.gradeLevel' | translate }} <span class="required-asterisk">*</span></label>
                  <c11n-select
                    [hideLabel]="true"
                    [hintText]="''"
                    [hasError]="isSubmittedAndInvalid && gradeKitOrders.controls[i].controls?.gradeLevel?.errors"
                    errorText="{{ 'formErrors.grade.required' | translate }}" >
                    <select 
                      c11nSelectInput 
                      id="gradeLevel_{{gradeKitOrder.value.tempId}}"
                      formControlName="gradeLevel"
                      required 
                      attr.aria-describedby="grade-level-{{gradeKitOrder.value.tempId}}-description">
                      <option value="" data-option="placeholder" disabled selected>
                        {{ 'formFields.select' | translate }}
                      </option>
                      <option *ngFor="let grade of grades | keyvalue : preserveOriginalOrder" [ngValue]="grade.key">{{ grade.value }}</option>
                    </select>
                  </c11n-select>
                </div>
                <div class="col-5 col-md-3">
                  <label c11n-label for="numberOfStudents_{{gradeKitOrder.value.tempId}}">{{ 'formFields.numberOfStudents' | translate }} <span class="required-asterisk">*</span></label>
                  <c11n-input
                    [hasError]="isSubmittedAndInvalid && gradeKitOrders.controls[i].controls?.numberOfStudents?.errors">
                    <input 
                      c11nInput 
                      type="text"
                      inputmode="decimal"
                      formControlName="numberOfStudents"
                      id="numberOfStudents_{{gradeKitOrder.value.tempId}}"
                      [imask]="integerMask"
                      [unmask]="true"
                      attr.aria-describedby="num-students-{{gradeKitOrder.value.tempId}}-desc"
                      />
                  </c11n-input>
                  <c11n-hint-error
                    [hasError]="isSubmittedAndInvalid && gradeKitOrders.controls[i].controls?.numberOfStudents?.getError('required')"
                    *ngIf="isSubmittedAndInvalid && gradeKitOrders.controls[i].controls?.numberOfStudents?.getError('required')"
                    errorText="{{ 'formErrors.numberOfStudents.required' | translate }}" 
                    hintErrorId="num-students-{{gradeKitOrder.value.tempId}}-desc">
                  </c11n-hint-error>
                  <c11n-hint-error
                    [hasError]="isSubmittedAndInvalid && gradeKitOrders.controls[i].controls?.numberOfStudents?.getError('min')"
                    *ngIf="isSubmittedAndInvalid && gradeKitOrders.controls[i].controls?.numberOfStudents?.getError('min')"
                    errorText="{{ 'formErrors.numberOfStudents.min' | translate }}" 
                    hintErrorId="num-students-{{gradeKitOrder.value.tempId}}-desc">
                  </c11n-hint-error>
                  <c11n-hint-error
                    [hasError]="isSubmittedAndInvalid && gradeKitOrders.controls[i].controls?.numberOfStudents?.getError('max')"
                    *ngIf="isSubmittedAndInvalid && gradeKitOrders.controls[i].controls?.numberOfStudents?.getError('max')"
                    errorText="{{ 'formErrors.numberOfStudents.max' | translate }}" 
                    hintErrorId="num-students-{{gradeKitOrder.value.tempId}}-desc">
                  </c11n-hint-error>
                </div>
                <div class="col-8 col-sm-9 col-md-4">
                  <label c11n-label for="language_{{gradeKitOrder.value.tempId}}">{{ 'formFields.language' | translate }} <span class="required-asterisk">*</span></label>
                  <div class="c11n-radio-group radio-buttons">
                    <fieldset id="radio-group">
                      <legend class="c11n-radio-group__legend--hidden">{{ 'formFields.language' | translate }}</legend>
                      <div class="storybook-horizontal-radios">
                        <div class="c11n-radio c11n-radio--bold-label">
                          <input class="c11n-radio__input" type="radio" 
                            formControlName="language_{{gradeKitOrder.value.tempId}}"
                            attr.name="language_{{gradeKitOrder.value.tempId}}" 
                            id="english_{{gradeKitOrder.value.tempId}}" 
                            value="English">
                          <label class="c11n-radio__label" for="english_{{gradeKitOrder.value.tempId}}">
                            <div class="c11n-radio__focus-element"></div>
                            <span class="c11n-radio__label-content">{{ 'language.english' | translate }}</span>
                            <span class="c11n-radio__descriptive-label">
                              {{ 'language.english' | translate }}
                            </span>
                            <svg viewBox="0 0 16 16">
                              <circle class="background" cx="8" cy="8" r="7.5"></circle>
                              <circle class="foreground" cx="8" cy="8" r="4"></circle>
                            </svg>
                          </label>
                        </div>
                    
                        <div class="c11n-radio c11n-radio--bold-label">
                          <input class="c11n-radio__input" type="radio" 
                            formControlName="language_{{gradeKitOrder.value.tempId}}"
                            attr.name="language_{{gradeKitOrder.value.tempId}}"  
                            id="spanish_{{gradeKitOrder.value.tempId}}" 
                            value="Spanish">
                          <label class="c11n-radio__label" for="spanish_{{gradeKitOrder.value.tempId}}">
                            <div class="c11n-radio__focus-element"></div>
                            <span class="c11n-radio__label-content c11n-text-md">{{ 'language.spanish' | translate }}</span>
                            <span class="c11n-radio__descriptive-label">
                              {{ 'language.spanish' | translate }}
                            </span>
                            <svg viewBox="0 0 16 16">
                              <circle class="background" cx="8" cy="8" r="7.5"></circle>
                              <circle class="foreground" cx="8" cy="8" r="4"></circle>
                            </svg>
                          </label>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                  <c11n-hint-error
                    [hasError]="isSubmittedAndInvalid && gradeKitOrders.controls[i].controls?.language?.errors"
                    [errorText]="'Please choose one.'"
                    [hintErrorId]="'language-{{ i }}-description'" >
                  </c11n-hint-error>
                </div>
                <div class="col-4 col-sm-3 col-md-1 remove-button" *ngIf="gradeKitOrders.controls.length > 1">
                  <p class="c11n-text-sm button-box">
                    <a
                      *ngIf="isSmallScreen"
                      c11n-link
                      href="javascript:void(0);"
                      [iconName]="'remove'"
                      [variant]="'secondary-independent'"
                      attr.aria-label="{{ ('orderMaterials.remove_aria_label' | translate) + ' ' + (i+1) }}"
                      title="{{ 'orderMaterials.remove_aria_label' | translate }}"
                      (click)="onRemoveRow(i)"
                    >
                      {{ 'orderMaterials.remove' | translate}}
                    </a>
                    <a
                      *ngIf="!isSmallScreen;"
                      c11n-link
                      href="javascript:void(0);"
                      [iconName]="'remove'"
                      [variant]="'secondary-independent'"
                      attr.aria-label="{{ ('orderMaterials.remove_aria_label' | translate) + ' ' + (i+1) }}"
                      title="{{ 'orderMaterials.remove_aria_label' | translate }}"
                      (click)="onRemoveRow(i)"
                    ></a> 
                  </p>
                </div>
              </div>
            </div>

            <div class="row w-100 inherit-row-gap">
              <p class="c11n-text-md">
                <button 
                  *ngIf="gradeKitOrders.length < 10"
                  type="button" 
                  c11n-link 
                  (click)="onAddRow()" 
                  [iconName]="'plus'" 
                  [iconPosition]="'leading'">
                  {{ 'orderMaterials.addGradeKit' | translate }}
                </button>
              </p>
            </div>
          </div>
        </div>

        <div class="form-section">
          <h3 class="c11n-text-lg-headline m-0">{{ 'orderMaterials.sections.shipping' | translate }}</h3>
          <div>
            <span class="c11n-text-sm--bold-italic">{{ 'orderMaterials.shippingNote.pleaseNote' | translate }}</span>
            <span class="c11n-text-sm--regular-italic"> {{ 'orderMaterials.shippingNote.message' | translate }}</span>
          </div>

          <div class="field-group">
            <div class="row w-100">
              <div class="col-sm-6">
                <label c11n-label for="country">{{ 'formFields.country' | translate }} <span class="required-asterisk">*</span></label>
                <c11n-select
                  [hideLabel]="true"
                  [hintText]="''"
                  [hasError]="isSubmittedAndInvalid && orderMaterialsForm.controls['country'].errors"
                  errorText="{{ 'formErrors.country.required' | translate }}" 
                  (stateChange)="onShippingAddressCountryChange($event)">
                  <select c11nSelectInput required id="country" name="country" formControlName="country" [attr.aria-describedby]="'country-description'">
                    <option *ngFor="let country of countries | keyvalue : preserveOriginalOrder" [value]="country.value">{{ 'countries.' + country.key | translate }}</option>
                  </select>
                </c11n-select>
              </div>
            </div>

            <div class="dynamic-address-fields" formGroupName="shippingAddress">
              <div class="row w-100 create-row-gap">
                <div class="col-sm-8">
                  <label c11n-label for="streetAddress">{{ 'formFields.streetAddress' | translate }} <span class="required-asterisk">*</span></label>
                  <c11n-input 
                    [hasError]="isSubmittedAndInvalid && shippingAddress.controls.streetAddress?.errors">
                      <input
                        c11nInput
                        formControlName="streetAddress" 
                        id="streetAddress"
                        name="streetAddress"
                        autocomplete="address-line1"
                        [attr.aria-describedby]="'street-address-description'"
                      />
                  </c11n-input>
                  <c11n-hint-error 
                    [hasError]="isSubmittedAndInvalid && shippingAddress.controls.streetAddress.hasError('required')"
                    *ngIf="isSubmittedAndInvalid && shippingAddress.controls.streetAddress.hasError('required')"
                    [hintErrorId]="'street-address-description'" 
                    errorText="{{ 'formErrors.streetAddress.required' | translate }}" 
                    >
                  </c11n-hint-error>
                  <c11n-hint-error 
                    [hasError]="isSubmittedAndInvalid && shippingAddress.controls.streetAddress.hasError('maxlength')"
                    *ngIf="isSubmittedAndInvalid && shippingAddress.controls.streetAddress.hasError('maxlength')"
                    [hintErrorId]="'street-address-description'"
                    errorText="{{ 'formErrors.streetAddress.max' | translate }}" >
                  </c11n-hint-error>
                  <c11n-hint-error 
                    [hasError]="isSubmittedAndInvalid && 
                      shippingAddress.controls.streetAddress.hasError('pattern') &&
                      !(shippingAddress.controls.streetAddress.hasError('maxlength'))"
                    *ngIf="isSubmittedAndInvalid && 
                      shippingAddress.controls.streetAddress.hasError('pattern') &&
                      !(shippingAddress.controls.streetAddress.hasError('maxlength'))"
                    [hintErrorId]="'street-address-description'"
                    errorText="{{ 'formErrors.streetAddress.specialCharacters' | translate }}" >
                  </c11n-hint-error>
                </div>
                <div class="col-sm-4">
                  <label c11n-label for="secondaryAddressUnit">{{ 'formFields.secondaryAddressUnit' | translate }}</label>
                  <c11n-input 
                    [hasError]="isSubmittedAndInvalid && shippingAddress.controls.secondaryAddressUnit?.errors">
                      <input
                        c11nInput
                        formControlName="secondaryAddressUnit" 
                        id="secondaryAddressUnit"
                        name="secondaryAddressUnit"
                        autocomplete="address-line2"
                        [attr.aria-describedby]="'secondary-address-unit-description'"
                      />
                  </c11n-input>
                  <c11n-hint-error 
                    [hasError]="isSubmittedAndInvalid && shippingAddress.controls.secondaryAddressUnit.hasError('maxlength')"
                    *ngIf="isSubmittedAndInvalid && shippingAddress.controls.secondaryAddressUnit.hasError('maxlength')"
                    [hintErrorId]="'secondary-address-unit-description'"
                    errorText="{{ 'formErrors.secondaryAddressUnit.max' | translate }}" >
                  </c11n-hint-error>
                  <c11n-hint-error 
                    [hasError]="isSubmittedAndInvalid && 
                      shippingAddress.controls.secondaryAddressUnit.hasError('pattern') &&
                      !(shippingAddress.controls.secondaryAddressUnit.hasError('maxlength'))"
                    *ngIf="isSubmittedAndInvalid && 
                      shippingAddress.controls.secondaryAddressUnit.hasError('pattern') &&
                      !(shippingAddress.controls.secondaryAddressUnit.hasError('maxlength'))"
                    [hintErrorId]="'secondary-address-unit-description'"
                    errorText="{{ 'formErrors.secondaryAddressUnit.specialCharacters' | translate }}" >
                  </c11n-hint-error>
                </div>
              </div>
  
              <div *ngIf="orderMaterialsForm.value.country === this.countries.unitedStates" class="row w-100 create-row-gap">
                <div class="col-sm-6">
                  <label c11n-label for="city">{{ 'formFields.city' | translate }} <span class="required-asterisk">*</span></label>
                  <c11n-input 
                    [hasError]="isSubmittedAndInvalid && shippingAddress.controls.city?.errors">
                      <input
                        c11nInput
                        formControlName="city" 
                        id="city"
                        name="city"
                        [attr.aria-describedby]="'city-description'"
                        autocomplete="address-level2"
                      />
                  </c11n-input>
                  <c11n-hint-error 
                    [hasError]="isSubmittedAndInvalid && shippingAddress.controls.city.hasError('required')"
                    *ngIf="isSubmittedAndInvalid && shippingAddress.controls.city.hasError('required')"
                    [hintErrorId]="'city-description'" 
                    errorText="{{ 'formErrors.city.required' | translate }}" 
                    >
                  </c11n-hint-error>
                  <c11n-hint-error 
                    [hasError]="isSubmittedAndInvalid && shippingAddress.controls.city.hasError('maxlength')"
                    *ngIf="isSubmittedAndInvalid && shippingAddress.controls.city.hasError('maxlength')"
                    [hintErrorId]="'city-description'"
                    errorText="{{ 'formErrors.city.max' | translate }}" >
                  </c11n-hint-error>
                  <c11n-hint-error 
                    [hasError]="isSubmittedAndInvalid && 
                      shippingAddress.controls.city.hasError('pattern') &&
                      !(shippingAddress.controls.city.hasError('maxlength'))"
                    *ngIf="isSubmittedAndInvalid && 
                      shippingAddress.controls.city.hasError('pattern') &&
                      !(shippingAddress.controls.city.hasError('maxlength'))"
                    [hintErrorId]="'city-description'"
                    errorText="{{ 'formErrors.city.specialCharacters' | translate }}" >
                  </c11n-hint-error>
                </div>
  
                <div class="col-sm-2">
                  <label c11n-label for="state">{{ 'formFields.state' | translate }} <span class="required-asterisk">*</span></label>
                  <c11n-input 
                    [hintText]="''"
                    [hasError]="isSubmittedAndInvalid && shippingAddress.controls.state?.errors">
                    <input 
                      c11nInput
                      aria-describedby="state-description"
                      formControlName="state"
                      id="state"
                      name="state"
                      maxlength="2"
                      autocomplete="address-level1"
                      (input)="
                    shippingAddress
                      .get('state')
                      ?.setValue($any($event.target).value?.toUpperCase())
                  "
                      autocapitalize="characters"
                      type="text"/>
                  </c11n-input>
                  <c11n-hint-error 
                    [hasError]="isSubmittedAndInvalid && shippingAddress.controls.state.hasError('required')"
                    *ngIf="isSubmittedAndInvalid && shippingAddress.controls.state.hasError('required')"
                    [hintErrorId]="'state-description'"
                    errorText="{{ 'formErrors.state.required' | translate }}" >
                  </c11n-hint-error>
                  <c11n-hint-error 
                    [hasError]="isSubmittedAndInvalid && shippingAddress.controls.state.hasError('isIn') && !(shippingAddress.controls.state.hasError('required'))"
                    *ngIf="isSubmittedAndInvalid && shippingAddress.controls.state.hasError('isIn') && !(shippingAddress.controls.state.hasError('required'))"
                    [hintErrorId]="'state-description'"
                    errorText="{{ 'formErrors.state.invalid' | translate }}">
                  </c11n-hint-error>
                </div>
  
                <div class="col-sm-4">
                  <label c11n-label for="postalCode">{{ 'formFields.zipCode' | translate }} <span class="required-asterisk">*</span></label>
                  <c11n-input 
                    [hasError]="isSubmittedAndInvalid && shippingAddress.controls.postalCode?.errors">
                      <input
                        c11nInput
                        formControlName="postalCode" 
                        id="postalCode"
                        name="postalCode"
                        [attr.aria-describedby]="'postal-code-description'"
                        [imask]="zipCodeMask"
                        autocomplete="postal-code"
                      />
                  </c11n-input>
                  <c11n-hint-error 
                    [hasError]="isSubmittedAndInvalid && shippingAddress.controls.postalCode.hasError('required')"
                    *ngIf="isSubmittedAndInvalid && shippingAddress.controls.postalCode.hasError('required')"
                    [hintErrorId]="'postal-code-description'"
                    errorText="{{ 'formErrors.zipCode.required' | translate }}">
                  </c11n-hint-error>
                  <c11n-hint-error 
                    [hasError]="isSubmittedAndInvalid && shippingAddress.controls.postalCode.hasError('inValidZip') && !(shippingAddress.controls.postalCode.hasError('required'))"
                    *ngIf="isSubmittedAndInvalid && shippingAddress.controls.postalCode.hasError('inValidZip') && !(shippingAddress.controls.postalCode.hasError('required'))"
                    [hintErrorId]="'postal-code-description'"
                    errorText="{{ 'formErrors.zipCode.invalid' | translate }}">
                  </c11n-hint-error>
                </div>
              </div>
  
              <div *ngIf="orderMaterialsForm.value.country === this.countries.canada" class="row w-100 create-row-gap">
                <div class="col-sm-5">
                  <label c11n-label for="city">{{ 'formFields.city' | translate }} <span class="required-asterisk">*</span></label>
                  <c11n-input 
                    [hasError]="isSubmittedAndInvalid && shippingAddress.controls.city?.errors">
                      <input
                        c11nInput
                        formControlName="city" 
                        id="city"
                        name="city"
                        [attr.aria-describedby]="'city-description'"
                        autocomplete="address-level2"
                      />
                  </c11n-input>
                  <c11n-hint-error 
                    [hasError]="isSubmittedAndInvalid && shippingAddress.controls.city.hasError('required')"
                    *ngIf="isSubmittedAndInvalid && shippingAddress.controls.city.hasError('required')"
                    [hintErrorId]="'city-description'" 
                    errorText="{{ 'formErrors.city.required' | translate }}"
                    >
                  </c11n-hint-error>
                  <c11n-hint-error 
                    [hasError]="isSubmittedAndInvalid && shippingAddress.controls.city.hasError('maxlength')"
                    *ngIf="isSubmittedAndInvalid && shippingAddress.controls.city.hasError('maxlength')"
                    [hintErrorId]="'city-description'"
                    errorText="{{ 'formErrors.city.max' | translate }}">
                  </c11n-hint-error>
                  <c11n-hint-error 
                    [hasError]="isSubmittedAndInvalid && 
                      shippingAddress.controls.city.hasError('pattern') &&
                      !(shippingAddress.controls.city.hasError('maxlength'))"
                    *ngIf="isSubmittedAndInvalid && 
                      shippingAddress.controls.city.hasError('pattern') &&
                      !(shippingAddress.controls.city.hasError('maxlength'))"
                    [hintErrorId]="'city-description'"
                    errorText="{{ 'formErrors.city.specialCharacters' | translate }}">
                  </c11n-hint-error>
                </div>
  
                <div class="col-sm-4">
                  <label c11n-label for="province">{{ 'formFields.province' | translate }} <span class="required-asterisk">*</span></label>
                  <c11n-select
                      [hintText]="''"
                      errorText="{{ 'formErrors.province.required' | translate }}"
                      [hasError]="isSubmittedAndInvalid && shippingAddress.controls.province?.errors"
                      [hideLabel]="true"
                      >
                      <select c11nSelectInput id="province" required formControlName="province">
                        <option value="" data-option="placeholder" disabled selected>{{ 'formFields.select' | translate }}</option>
                        <option *ngFor="let province of provinces" [value]="province.canadianProvinceCode">{{ province.name }}</option>
                      </select>
                  </c11n-select>
                </div>
  
                <div class="col-sm-3">
                  <label c11n-label for="postalCode">{{ 'formFields.postalCode' | translate }} <span class="required-asterisk">*</span></label>
                  <c11n-input 
                    [hasError]="isSubmittedAndInvalid && shippingAddress.controls.postalCode?.errors">
                      <input
                        c11nInput
                        formControlName="postalCode" 
                        id="postalCode"
                        name="postalCode"
                        autocomplete="postal-code"
                        [attr.aria-describedby]="'postal-code-description'"
                      />
                  </c11n-input>
                  <c11n-hint-error 
                    [hasError]="isSubmittedAndInvalid && shippingAddress.controls.postalCode.hasError('required')"
                    *ngIf="isSubmittedAndInvalid && shippingAddress.controls.postalCode.hasError('required')"
                    [hintErrorId]="'postal-code-description'"
                    errorText="{{ 'formErrors.postalCode.required' | translate }}">
                  </c11n-hint-error>
                  <c11n-hint-error 
                    [hasError]="isSubmittedAndInvalid && shippingAddress.controls.postalCode.hasError('pattern') && !(shippingAddress.controls.postalCode.hasError('required'))"
                    *ngIf="isSubmittedAndInvalid && shippingAddress.controls.postalCode.hasError('pattern') && !(shippingAddress.controls.postalCode.hasError('required'))"
                    [hintErrorId]="'postal-code-description'"
                    errorText="{{ 'formErrors.postalCode.invalid' | translate }}">
                  </c11n-hint-error>
                </div>
              </div>
            </div>

            <div class="row w-100">
              <div class="col-sm-4">
                <label c11n-label for="phoneNumber">{{ 'formFields.phoneNumber' | translate }} <span class="required-asterisk">*</span></label>
                <c11n-input
                  [hasError]="isSubmittedAndInvalid && 
                  orderMaterialsForm.controls['phoneNumber'].hasError('required')"
                  >
                  <input
                    c11nInput
                    formControlName="phoneNumber"
                    id="phoneNumber"
                    name="phoneNumber"
                    type="tel"
                    [imask]="domesticPhoneNumberMask"
                    [attr.aria-describedby]="'phone-number-description'"
                    autocomplete="tel-national"/>
                </c11n-input>
                <c11n-hint-error
                  hintText="{{ 'orderMaterials.phoneNumberNote' | translate }}"
                  *ngIf="!(isSubmittedAndInvalid) || !(orderMaterialsForm.controls['phoneNumber']?.errors)"
                  [hintErrorId]="'phone-number-description'">
                </c11n-hint-error>
                <c11n-hint-error
                  [hasError]="isSubmittedAndInvalid && orderMaterialsForm.controls['phoneNumber'].getError(
                    'required'
                  )"
                  *ngIf="isSubmittedAndInvalid && !(orderMaterialsForm.controls['phoneNumber'].getError('pattern'))"
                  errorText="{{ 'formErrors.phoneNumber.required' | translate }}"
                  [hintErrorId]="'phone-number-description'"
                  >
                </c11n-hint-error>
                <c11n-hint-error
                  [hasError]="isSubmittedAndInvalid && orderMaterialsForm.controls['phoneNumber'].getError(
                    'pattern'
                  )"
                  *ngIf="isSubmittedAndInvalid && orderMaterialsForm.controls['phoneNumber'].getError(
                    'pattern'
                  )"
                  errorText="{{ 'formErrors.phoneNumber.invalid' | translate }}"
                  [hintErrorId]="'phone-number-description'"
                >
                </c11n-hint-error>
              </div>
            </div>
          </div>
        </div>

        <div class="form-section">
          <h3 class="c11n-text-lg-headline m-0">{{ 'orderMaterials.sections.additional' | translate }}</h3>

          <div class="field-group">
            <div class="row w-100 inherit-row-gap">
              <div class="col-sm-7">
                <label c11n-label for="reference">{{ 'formFields.reference' | translate }} <span class="required-asterisk">*</span></label>
                <c11n-select
                  [hideLabel]="true"
                  [hintText]="''"
                  [hasError]="isSubmittedAndInvalid && orderMaterialsForm.controls['reference'].errors"
                  errorText="{{ 'formErrors.reference.required' | translate }}">
                  <select c11nSelectInput required id="reference" name="reference" formControlName="reference" [attr.aria-describedby]="'reference-description'">
                    <option value="" data-option="placeholder" disabled selected>
                      {{ 'formFields.select' | translate }}
                    </option>
                    <option [attr.aria-label]="reference.value"
                      *ngFor="let reference of references | keyvalue: preserveOriginalOrder" [ngValue]="reference.key">
                      {{ reference.value }}
                    </option>
                  </select>
                </c11n-select>
              </div>
            </div>
  
            <div class="row w-100">
              <div class="col-12 d-flex align-items-center">
                <c11n-checkbox [hideLabel]="true">
                  <input 
                    c11nCheckboxInput 
                    formControlName="isTermsAndConditionsAccepted"
                    type="checkbox"
                    aria-label="I agree to the Terms & Conditions"
                    id="isTermsAndConditionsAccepted"
                    [attr.aria-labelledby]="'isTermsAndConditionsAccepted'"
                    [attr.aria-describedby]="'terms-and-conditions-description'"/>
                </c11n-checkbox>
                  <label 
                    c11n-label
                    class="checkbox-label"
                    for="isTermsAndConditionsAccepted">
                    {{ 'formFields.terms.agree' | translate }}  
                    <a c11n-link 
                      [routerLink]="signupExternalLinks.terms_conditions_url | langLink"
                      target="_blank"
                    >{{ 'formFields.terms.termsLink' | translate }}</a>&nbsp;<span class="required-asterisk">*</span>
                  </label>
              </div>
              <div class="col-12" *ngIf="isSubmittedAndInvalid && orderMaterialsForm.controls['isTermsAndConditionsAccepted']?.errors">
                <c11n-hint-error
                  [hasError]="isSubmittedAndInvalid && orderMaterialsForm.controls['isTermsAndConditionsAccepted'].getError('required')"
                  errorText="{{ 'formErrors.terms.required' | translate }}" 
                  [hintErrorId]="'terms-and-conditions-description'" >
                </c11n-hint-error>
              </div>
            </div>
  
            <div class="row w-100">
              <div class="col-12 d-flex align-items-center">
                <c11n-checkbox [hideLabel]="true">
                  <input 
                    c11nCheckboxInput 
                    formControlName="isPrivacyPolicyAccepted"
                    type="checkbox"
                    aria-label="I agree to the Privacy Policy"
                    id="isPrivacyPolicyAccepted"
                    [attr.aria-labelledby]="'isPrivacyPolicyAccepted'"
                    [attr.aria-describedby]="'privacy-policy-description'"/>
                </c11n-checkbox>
                  <label 
                    c11n-label
                    class="checkbox-label"
                    for="isPrivacyPolicyAccepted">
                    {{ 'formFields.privacyPolicy.agree' | translate }} 
                    <a c11n-link 
                      [routerLink]="signupExternalLinks.privacy_policy_url | langLink"
                      target="_blank"
                    >{{ 'formFields.privacyPolicy.privacyPolicyLink' | translate }}</a>&nbsp;<span class="required-asterisk">*</span>
                  </label>
              </div>
              <div class="col-12" *ngIf="isSubmittedAndInvalid && orderMaterialsForm.controls['isPrivacyPolicyAccepted']?.errors">
                <c11n-hint-error
                  [hasError]="isSubmittedAndInvalid && orderMaterialsForm.controls['isPrivacyPolicyAccepted'].getError('required')"
                  errorText="{{ 'formErrors.privacyPolicy.required' | translate }}" 
                  [hintErrorId]="'privacy-policy-description'" >
                </c11n-hint-error>
              </div>
            </div>
          </div>
        </div>

        <div class="form-section">
          <re-captcha
            formControlName="captchaResponse" 
            siteKey="6LdApAYqAAAAAOQW_aWW2F_vYOZZU36XKu2dWfaU">
          </re-captcha>
          <c11n-hint-error
            [hasError]="(orderMaterialsForm.controls['captchaResponse'].touched || isSubmittedAndInvalid) && 
              orderMaterialsForm.controls['captchaResponse'].getError('required')"
            *ngIf="(orderMaterialsForm.controls['captchaResponse'].touched || isSubmittedAndInvalid) && 
              orderMaterialsForm.controls['captchaResponse'].getError('required')"
            [hintErrorId]="'captchaResponse-description'"
            errorText="{{ 'formErrors.reCaptcha.required' | translate }}" 
            >
          </c11n-hint-error>
        </div>

        <c11n-button
          class="submit-btn"
          labelText="{{ 'orderMaterials.submit' | translate }}"
          buttonType="submit"
          [isWaiting]="isSending"
          [attr.aria-describedby]="'submit-description'">
        </c11n-button>
      </form>
    </div>
    <div *ngIf="emailSent" class="submit-confirmation">
      <img src="assets/images/green_checkmark.svg" alt="Green checkmark" class="submit-icon">
      <div class="c11n-text-3xl-headline">Thank you!</div>
      <div class="c11n-text-xl">Your request has been received.</div>
    </div>
  </div>
</div>

<!-- School Search constellation component-->

<ng-template #schoolSearchTemplate>
  <div class="row w-100 inherit-row-gap">
    <div class="col-12">
      <div role="search"
        class="c11n-search c11n-search--medium c11n-search--below c11n-search--attached c11n-search--on-light">
        <c11n-search #searchComponent [id]="'myce_search_school'" [labelText]="'formFields.schoolSearch.search_label' | translate"
          [hasMenu]="false" (stateChange)="onSearchAction($event)" 
          [attr.aria-describedby]="'myce_search_school-input-description'"></c11n-search>
        <c11n-hint-error [hasError]="
          isSubmittedAndInvalid && !triggeredSchoolSearch &&
          orderMaterialsForm.controls['schoolMetaDataId'].hasError('required')
          " *ngIf="
            isSubmittedAndInvalid && !triggeredSchoolSearch &&
            orderMaterialsForm.controls['schoolMetaDataId'].hasError('required')
          " [hintErrorId]="'myce_search_school-input-description'" [errorText]="
            'formErrors.school.required' | translate
          " [size]="'medium'">
        </c11n-hint-error>

        <div *ngIf="triggeredSchoolSearch" class="c11n-menu c11n-search__menu" role="menu" id="search-menu">
          <div class="c11n-menu__menu c11n-search__menu__menu">
            <div class="c11n-menu__group" role="group">
              <button *ngFor="let school of schools; trackBy: trackBySchoolId" [attr.aria-label]="school.name"
                type="button" class="c11n-menu__item c11n-search__menu__item" role="menuitem"
                (click)="onSchoolSelect(school)">
                <span class="c11n-search__menu__item_label">
                  {{ school.schoolName }}
                </span>
              </button>
            </div>

            <div class="c11n-search__menu__summary">
              <div class="c11n-search__menu__summary__heading" [ngSwitch]="schools.length">
                <ng-container *ngSwitchCase="0">{{ 'formFields.schoolSearch.noResults' | translate }}</ng-container>
                <ng-container *ngSwitchCase="1">{{ 'formFields.schoolSearch.oneResult' | translate }}</ng-container>
                <ng-container *ngSwitchDefault>{{ 'formFields.schoolSearch.multipleResults' | translate:{ dynamicText: schools.length } }}</ng-container>
              </div>
              <button type="button" class="c11n-menu__item c11n-search__menu__item c11n-search__menu__summary__see-all"
                role="menuitem" (click)="onManualAdd()">
                <span class="c11n-search__menu__item__label">
                  <span class="c11n-menu__item-label">{{ 'formFields.schoolSearch.addSchoolManually' | translate }}</span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #selectedSchoolFromSearch>
  <div class="row w-100 inherit-row-gap">
    <div class="col-12">
      <div class="selected-school-container">
        <div class="back-to-search">
          <a c11n-link [iconName]="'search'" [variant]="'primary-independent'" [iconPosition]="'leading'"
            [fontWeight]="'bold'" href="javascript:void(0)" (click)="onSearchNewSchool()">{{ 'formFields.schoolSearch.newSearch' | translate }}</a>
        </div>
        <div class="selected-school">
          <div class="selected-school__name">
            <div class="selected-school__name__text">
              {{ 'formFields.schoolSearch.schoolName' | translate }}
            </div>
            <div class="selected-school__name__value">
              {{selectedSchoolMetaData.schoolName}}
            </div>
          </div>
          <div class="selected-school__zip">
            <div class="selected-school__zip__text">
              {{ 'formFields.schoolSearch.schoolZipCode' | translate }}
            </div>
            <div class="selected-school__zip__value">
              {{selectedSchoolMetaData.zipCode}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
